import "./wordmark.css";

/** Shared brand contents; the caller owns the link and its destination. */
export function GardenWordmark() {
  return (
    <>
      <img className="garden-brand-icon" src="/garden/favicon.svg" alt="" />
      <span className="garden-brand-name">Garden</span>
      <small>by Sauna</small>
    </>
  );
}
